import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['crankset-filters-length', 'crankset-filters-length--active'])
}
const _hoisted_2 = { class: "crankset-filters-length__buttons" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCranksetStore } from '@/store/cranksetStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { BfFlex, BfInput, BfButton, Colors } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { NSlider } from 'naive-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'CranksetFiltersLength',
  emits: ['save', 'cancel'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const lastLength = ref(0)
const minLength = ref(140)
const maxLength = ref(175)

const emit = __emit

const cranksetStore = useCranksetStore()
const measurementStore = useMeasurementStore()
const { filterLength } = storeToRefs(cranksetStore)

const setLastLength = () => {
  lastLength.value = filterLength.value
}

const checkLength = () => {
  if (
    filterLength.value < minLength.value ||
    filterLength.value > maxLength.value
  ) {
    filterLength.value = lastLength.value
  }
}

const save = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.crankset.active = filterLength.value
  }

  emit('save')
}

const cancel = () => {
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BfFlex), {
      align: "center",
      gap: "1.6rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BfInput), {
          modelValue: _unref(filterLength),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterLength) ? (filterLength).value = $event : null)),
          class: "crankset-filters-length__input",
          type: "number",
          unit: _unref(t)('common.unit.mm'),
          min: minLength.value,
          max: maxLength.value,
          step: 2.5,
          onFocus: setLastLength,
          onBlur: checkLength
        }, null, 8, ["modelValue", "unit", "min", "max"]),
        _createVNode(_unref(NSlider), {
          value: _unref(filterLength),
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterLength) ? (filterLength).value = $event : null)),
          class: "crankset-filters-length__slider",
          min: minLength.value,
          max: maxLength.value,
          step: 2.5
        }, null, 8, ["value", "min", "max"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(BfButton), {
            color: _unref(Colors).Light,
            class: "crankset-filters-length__button",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_unref(BfButton), {
            color: _unref(Colors).Light,
            class: "crankset-filters-length__button",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})